// Anonymous vehicle-funnel instrumentation. Fire-and-forget POSTs so we can see
// where reg-searchers drop off (vehicle selected → product view → add to cart).
// No PII: a random per-browser session id in localStorage, never an email.

const API_URL = process.env.NEXT_PUBLIC_API_URL || 'https://api.autofrance.se/api';
const SID_KEY = 'af-funnel-sid';

function getSessionId(): string | null {
  if (typeof window === 'undefined') return null;
  try {
    let sid = localStorage.getItem(SID_KEY);
    if (!sid) {
      sid = (crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`);
      localStorage.setItem(SID_KEY, sid);
    }
    return sid;
  } catch {
    return null;
  }
}

type FunnelEvent = 'vehicle_selected' | 'product_view' | 'add_to_cart' | 'checkout_start';

interface FunnelData {
  ktype?: number;
  manufacturer?: string;
  model?: string;
  product_id?: number;
  source?: string;
  price?: number;
}

/** Fire a funnel event. Never throws, never blocks the UI. */
export function trackFunnel(event: FunnelEvent, data: FunnelData = {}): void {
  if (typeof window === 'undefined') return;
  try {
    const body = JSON.stringify({ event, session_id: getSessionId(), ...data });
    // Prefer sendBeacon (survives navigation), fall back to fetch keepalive.
    if (navigator.sendBeacon) {
      navigator.sendBeacon(`${API_URL}/track/funnel`, new Blob([body], { type: 'application/json' }));
    } else {
      fetch(`${API_URL}/track/funnel`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body,
        keepalive: true,
      }).catch(() => {});
    }
  } catch {
    /* swallow — instrumentation must never break the page */
  }
}
